module.exports = __webpack_public_path__ + "img/night.c30880c9.png";